module.exports = __webpack_public_path__ + "static/img/115.4a2b03f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/115.jpg
// module id = kPUE
// module chunks = 2